import { Button, Divider, Input, Table, Tooltip } from "antd";
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { openPopup2, POPUP_TYPE } from "../../../contexts/PopupContext";
import { AccountService } from "../../../util/services/account";
import { selectFactory } from "../../../util/store/factory/constants";
import { factoryActions } from "../../../util/store/factory/reducer";
import { selectRegion } from "../../../util/store/region/constants";
import { selectPermissions } from "../../../util/store/selectors";
import { IFactory, ITenant } from "../../../util/varibles/interface";
import { ACTION } from "../../../util/varibles/permission";
import { ColumnTemplates } from "../../../util/varibles/template";
import styles from "../style.module.scss";
import PopupEdit from "./PopupEdit";

const Factories: React.FC = () => {
    const [search, setSearch] = useState('');
    const factories = useSelector(selectFactory.factoriesAdmin);
    const loading = useSelector(selectFactory.loading);
    const [tenants, setTenants] = useState<ITenant[]>([]);
    const regions = useSelector(selectRegion.regions);
    const [canViewTenant, canCreateLocation, canUpdateLocation] = useSelector(selectPermissions([
        ACTION.TENANT.VIEW,
        ACTION.LOCATION.CREATE,
        ACTION.LOCATION.UPDATE,
    ]));
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(factoryActions.getsByAdmin())
        if (canViewTenant)
            AccountService.tenant().then(rs => setTenants(rs))
    }, [dispatch, canViewTenant]);

    const handleKeyDown = (e: any) => {
        if (e.key === 'Escape')
            setSearch('')
    }

    const handleClick = (data?: IFactory) => {

        openPopup2(<PopupEdit data={data} tenants={tenants} reload={() => dispatch(factoryActions.getsByAdmin())} />, {
            modalProps: {
                title: data ? ('Update factory: ' + data.name) : 'Add factory',
                width: '100%'
            },
            popupType: POPUP_TYPE.DRAWER
        })
    }

    const dataSource = useMemo(() => factories.filter(({ name }) => {
        return search.length === 0 || name.toLowerCase().includes(search.trim().toLowerCase())
    }), [factories, search]);

    return <div className={styles.content}>
        <div className='flex justify-end mb-10'>
            <Input
                value={search}
                onChange={(e: any) => setSearch(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder='Search by name'
                className={styles.search}
            />
            {canCreateLocation && <>
                <Divider className='divider-vertical' orientation='vertical' />
                <Tooltip title="Add factory">
                    <Button className='bt-primary bt-plus' type="primary" shape="circle"
                        onClick={() => handleClick()}
                    />
                </Tooltip>
            </>}
        </div>
        <Table {...{
            rowKey: "id",
            pagination: false,
            columns: [
                ColumnTemplates.Name,
                ColumnTemplates.WorkTime,
                ColumnTemplates.Phone,
                ColumnTemplates.Position,
                ColumnTemplates.Regions(regions),
                {
                    title: 'Owner',
                    dataIndex: 'tenant_id',
                    key: 'tenant_id',
                    render: (tenant_id: any) => tenants.reduce((list: any, tenant) => tenant.tenant_id === tenant_id
                        ? [...list, <span key={tenant_id}>{tenant.name}</span>]
                        : list, []),
                },
                ColumnTemplates.Edit({[ACTION.LOCATION.UPDATE]: canUpdateLocation}, handleClick)
            ],
            loading,
            dataSource
        }} />
    </div>;
};

export default Factories;
